export const environment = {
	production: true,
	apiUrl: 'https://ttqa.rqp.co'
	// apiUrl: 'http://localhost:8080/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts